import { EnvironmentConfig } from 'tmt-logger';

export interface Environment {
	production: boolean;
	authLayer_staging: string;
	authLayer_release: string;
	abstractionLayerStagingUrl: string;
	abstractionLayerReleaseUrl: string;
	loggerApiStagingUrl: string;
	loggerApiReleaseUrl: string;
	requirementsurl: string;
	redirect_url: string;
	auth_provider: string;
	auth_client_id: string;
	auth_url: string;
	auth_response_mode?: string;
	auth_scope?: string;
	logConfig: EnvironmentConfig;
	deliveryDatabase_url?: string;
	ddb_url: string;
	ecu_compare_url: string;
	configurator_url: string;
	executor_url: string;
	results_url: string;
	reports_url: string;
	vehicle_bookings_url: string;
	vehicle_follow_up_url: string;
	analyzer_url: string;
	webanalytics_url: string;
	nexus_url: string;
	parentDomain: string;
	environment: TargetEnvironment;
	serviceWorkerEnabled: boolean;
	flags: FlagsConfig;
	launchDarklyClientId: string;
  analyticsAppId?: string;
	analyticsSdkScriptUrl?: string;
}

export interface FlagsConfig {
	devTools: string;
	nexus: string;
	newDDBEcuCompare: string;
}

export enum TargetEnvironment {
	Default = 'Default',
	Hero = 'Hero',
}
